import styled, {keyframes} from 'styled-components';

import {colors, font} from 'theme';

export const ModalContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    width: 100%;
`;

export const ModalContainerCentered = styled(ModalContainer)`
    justify-content: center;
    align-items: center;
`;

export const ModalContainerSuccess = styled(ModalContainer)``;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 20px;
    width: 100%;
    height: auto;
`;

export const Title = styled.h2`
    width: 100%;
    height: 64px;
    font-family: ${font.family.primary};
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #1d2229;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FieldsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 21px;
    width: 100%;
    height: auto;
`;

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 4px;
    width: 100%;
    height: auto;
`;

export const FieldLabel = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 8px;
    width: 100%;
    height: 16px;
`;

export const CheckboxText = styled.span`
    font-family: ${font.family.primary};
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: ${colors.darkGrey};
`;

export const ArrowContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 10px;
    width: 100%;
    height: auto;
`;

export const ArrowText = styled(CheckboxText)`
    font-size: 20px;
    line-height: 20px;
    color: ${colors.brandPrimary};
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    gap: 20px;
    width: 100%;
    height: 44px;
`;

export const LoadingSubtitle = styled.div`
    box-sizing: border-box;
    width: auto;
    height: auto;
    font-family: ${font.family.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: ${colors.textPrimary};
`;

export const TitleSuccess = styled(LoadingSubtitle)`
    padding: 0 16px;
`;

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

export const ErrorMessage = styled.div`
    color: ${colors.danger};
    font-size: 12px;
    margin-top: 4px;
    font-family: ${font.family.primary};
`;

export const Loader = styled.div`
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: ${rotate} 2.3s infinite linear;
    margin-bottom: 60px;
`;

export const NoteContainer = styled.div`
    display: flex;
    align-items: flex-start;
    padding: 0px;
    gap: 4px;
    width: 100%;
    height: auto;
`;

export const NoteText = styled(CheckboxText)`
    font-size: 12px;
    line-height: 12px;
`;

export const ConfirmDescription = styled(CheckboxText)`
    width: 100%;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
`;
